import { render, staticRenderFns } from "./quotation.vue?vue&type=template&id=74be34e4&scoped=true&"
import script from "./quotation.vue?vue&type=script&lang=js&"
export * from "./quotation.vue?vue&type=script&lang=js&"
import style0 from "./quotation.vue?vue&type=style&index=0&id=74be34e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74be34e4",
  null
  
)

export default component.exports